import { ReactElement, ReactNode, useMemo } from 'react';
// Imported by file rather than through the queries barrel: the licence
// queries read this provider, so the barrel would close a cycle.
import { useFetchBeacons } from '../../queries/use-fetch-beacons';
import { useCompanyContext } from '@/companies/providers';
import { BeaconsContext } from './context';

type BeaconsProviderProps = {
    readonly children?: ReactNode;
};

export function BeaconsProvider(props: BeaconsProviderProps): ReactElement {
    const { children } = props;

    const { company } = useCompanyContext();

    const { beacons, status, refetch } = useFetchBeacons(company.id);

    const availableTags = useMemo(() => {
        if (!beacons) {
            return [];
        }

        const tags = new Set<string>();
        beacons.forEach((beacon) => {
            beacon.tags.forEach((tag) => tags.add(tag.trim()));
        });
        return Array.from(tags).sort();
    }, [beacons]);

    return (
        <BeaconsContext.Provider
            value={{
                beacons: beacons ?? [],
                availableTags,
                status,
                refetch
            }}
        >
            {children}
        </BeaconsContext.Provider>
    );
}
